export const PHONE_DEFAULT_TYPE: string = 'mobile';

export const DEFAULT_COUNTRY: string = 'US';

export const PREFERRED_COUNTRIES: string[] = ['us', 'br'];
